/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request body for updating enhanced game information
 * @export
 * @interface UpdateEnhancedGameInfoBody
 */
export interface UpdateEnhancedGameInfoBody {
    /**
     * Overwolf game ID (matches overwolfId in steam-matches.json)
     * @type {string}
     * @memberof UpdateEnhancedGameInfoBody
     */
    gameId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEnhancedGameInfoBody
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateEnhancedGameInfoBody
     */
    steamAppId?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateEnhancedGameInfoBody
     */
    steamName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEnhancedGameInfoBody
     */
    shortDescription?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateEnhancedGameInfoBody
     */
    genres?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateEnhancedGameInfoBody
     */
    developers?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateEnhancedGameInfoBody
     */
    publishers?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateEnhancedGameInfoBody
     */
    releaseDate?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEnhancedGameInfoBody
     */
    steamHeaderImage?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEnhancedGameInfoBody
     */
    steamCapsuleImage?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEnhancedGameInfoBody
     */
    steamBackground?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateEnhancedGameInfoBody
     */
    steamScreenshots?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateEnhancedGameInfoBody
     */
    categories?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof UpdateEnhancedGameInfoBody
     */
    recommendations?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateEnhancedGameInfoBody
     */
    achievements?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateEnhancedGameInfoBody
     */
    website?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateEnhancedGameInfoBody
     */
    timeTrackedGame?: boolean;
    /**
     * SEO-friendly URL slug for the game
     * @type {string}
     * @memberof UpdateEnhancedGameInfoBody
     */
    slug?: string;
}

/**
 * Check if a given object implements the UpdateEnhancedGameInfoBody interface.
 */
export function instanceOfUpdateEnhancedGameInfoBody(value: object): value is UpdateEnhancedGameInfoBody {
    if (!('gameId' in value) || value['gameId'] === undefined) return false;
    return true;
}

export function UpdateEnhancedGameInfoBodyFromJSON(json: any): UpdateEnhancedGameInfoBody {
    return UpdateEnhancedGameInfoBodyFromJSONTyped(json, false);
}

export function UpdateEnhancedGameInfoBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateEnhancedGameInfoBody {
    if (json == null) {
        return json;
    }
    return {
        
        'gameId': json['gameId'],
        'name': json['name'] == null ? undefined : json['name'],
        'steamAppId': json['steamAppId'] == null ? undefined : json['steamAppId'],
        'steamName': json['steamName'] == null ? undefined : json['steamName'],
        'shortDescription': json['shortDescription'] == null ? undefined : json['shortDescription'],
        'genres': json['genres'] == null ? undefined : json['genres'],
        'developers': json['developers'] == null ? undefined : json['developers'],
        'publishers': json['publishers'] == null ? undefined : json['publishers'],
        'releaseDate': json['releaseDate'] == null ? undefined : json['releaseDate'],
        'steamHeaderImage': json['steamHeaderImage'] == null ? undefined : json['steamHeaderImage'],
        'steamCapsuleImage': json['steamCapsuleImage'] == null ? undefined : json['steamCapsuleImage'],
        'steamBackground': json['steamBackground'] == null ? undefined : json['steamBackground'],
        'steamScreenshots': json['steamScreenshots'] == null ? undefined : json['steamScreenshots'],
        'categories': json['categories'] == null ? undefined : json['categories'],
        'recommendations': json['recommendations'] == null ? undefined : json['recommendations'],
        'achievements': json['achievements'] == null ? undefined : json['achievements'],
        'website': json['website'] == null ? undefined : json['website'],
        'timeTrackedGame': json['timeTrackedGame'] == null ? undefined : json['timeTrackedGame'],
        'slug': json['slug'] == null ? undefined : json['slug'],
    };
}

export function UpdateEnhancedGameInfoBodyToJSON(json: any): UpdateEnhancedGameInfoBody {
    return UpdateEnhancedGameInfoBodyToJSONTyped(json, false);
}

export function UpdateEnhancedGameInfoBodyToJSONTyped(value?: UpdateEnhancedGameInfoBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'gameId': value['gameId'],
        'name': value['name'],
        'steamAppId': value['steamAppId'],
        'steamName': value['steamName'],
        'shortDescription': value['shortDescription'],
        'genres': value['genres'],
        'developers': value['developers'],
        'publishers': value['publishers'],
        'releaseDate': value['releaseDate'],
        'steamHeaderImage': value['steamHeaderImage'],
        'steamCapsuleImage': value['steamCapsuleImage'],
        'steamBackground': value['steamBackground'],
        'steamScreenshots': value['steamScreenshots'],
        'categories': value['categories'],
        'recommendations': value['recommendations'],
        'achievements': value['achievements'],
        'website': value['website'],
        'timeTrackedGame': value['timeTrackedGame'],
        'slug': value['slug'],
    };
}

